import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
    fetchCateringsCouponsAPI,
    createCateringsCouponAPI,
    updateCateringsCouponAPI,
    deleteCateringsCouponAPI,
} from "../../../Servicefile/Coupnsapis";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

function Cateringsaddcoups() {
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [couponsData, setCouponsData] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const [formData, setFormData] = useState({
        offertype: "",
        couponcode: "",
        discount: "",
        startdate: "",
        enddate: "",
        vendorId: "",
        active: true,
        image: null,
    });

    const platformFormFields = [
        { label: "Coupon Code", name: "couponcode", type: "text" },
        { label: "Discount Percentage", name: "discount", type: "number" },
        { label: "Start Date", name: "startdate", type: "date" },
        { label: "End Date", name: "enddate", type: "date" },
        { label: "Active Status", name: "active", type: "checkbox" },
        { label: "Coupon Image", name: "image", type: "file" },
    ];

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            showLoader();
            const data = await fetchCateringsCouponsAPI();
            setCouponsData(data);
        } catch (error) {
            console.error("❌ Error fetching coupons:", error);
            alert("Error fetching coupons: " + error.message);
        } finally {
            hideLoader();
        }
    };

    const handleAddRow = () => {
        setFormData({
            offertype: "",
            couponcode: "",
            discount: "",
            startdate: "",
            enddate: "",
            vendorId: "",
            active: true,
            image: null,
        });
        setEditId(null);
        setIsFormModalOpen(true);
    };

    const handleEditRow = (item) => {
        setFormData({
            offertype: item.vendorId === null ? "App_Coupon" : "Vendor_Coupon",
            couponcode: item.code,
            discount: item.discountPercentage,
            startdate: item.startDate.split("T")[0],
            enddate: item.endDate.split("T")[0],
            vendorId: item.vendorId === null ? "" : item.vendorId,
            active: item.active,
            image: null,
        });
        setEditId(item.id);
        setIsFormModalOpen(true);
    };

    const handleDeleteRow = async (id) => {
        if (!window.confirm("Are you sure you want to delete this coupon?")) return;
        try {
            await deleteCateringsCouponAPI(id);
            alert("✅ Coupon deleted successfully!");
            fetchCoupons();
        } catch (error) {
            console.error("❌ Error deleting coupon:", error);
            alert("❌ Failed to delete coupon");
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                image: file,
            }));
        }
    };

    // ✅ CREATE (Add)
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const couponData = {
            code: formData.couponcode,
            discountPercentage: parseFloat(formData.discount),
            startDate: `${formData.startdate}T00:00:00`,
            endDate: `${formData.enddate}T23:59:59`,
            vendorId: 1,
            active: formData.active,
        };

        try {
            const result = await createCateringsCouponAPI(couponData, formData.image);
            // alert(`✅ Coupon created successfully: ${result.code}`);
            fetchCoupons();
            setIsFormModalOpen(false);
        } catch (error) {
            console.error("❌ Error creating coupon:", error);
            alert("❌ Failed to create coupon");
        }
    };

    // ✅ UPDATE (Edit)
    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        const couponData = {
            code: formData.couponcode,
            discountPercentage: parseFloat(formData.discount),
            startDate: `${formData.startdate}T00:00:00`,
            endDate: `${formData.enddate}T23:59:59`,
            vendorId: 1,
            active: formData.active,
        };

        try {
            const result = await updateCateringsCouponAPI(editId, couponData, formData.image);
            // alert(`✅ Coupon updated successfully: ${result.code}`);
            fetchCoupons();
            setIsFormModalOpen(false);
            setEditId(null);
        } catch (error) {
            console.error("❌ Error updating coupon:", error);
            alert("❌ Failed to update coupon");
        }
    };

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "2px" }}>
                <button onClick={handleAddRow} style={addButtonStyle}>Add+</button>
            </div>

            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>S.No</th>
                        <th style={tableHeaderStyle}>Code</th>
                        <th style={tableHeaderStyle}>Image</th>
                        <th style={tableHeaderStyle}>Discount %</th>
                        <th style={tableHeaderStyle}>Start Date</th>
                        <th style={tableHeaderStyle}>End Date</th>
                        <th style={tableHeaderStyle}>Active</th>
                        <th style={tableHeaderStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {couponsData.map((item, index) => (
                        <tr key={item.id}>
                            <td style={tableCellStyle}>{index + 1}</td>
                            <td style={tableCellStyle}>{item.code}</td>
                            <td style={tableCellStyle}>
                                {item.image ? (
                                    <img
                                        src={item.image}
                                        alt="Coupon"
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                        }}
                                    />
                                ) : (
                                    "No Image"
                                )}
                            </td>
                            <td style={tableCellStyle}>{item.discountPercentage}</td>
                            <td style={tableCellStyle}>{item.startDate}</td>
                            <td style={tableCellStyle}>{item.endDate}</td>
                            <td style={tableCellStyle}>{item.active ? "Yes" : "No"}</td>
                            <td style={tableCellStyle}>
                                <FaEdit
                                    style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
                                    onClick={() => handleEditRow(item)}
                                />
                                <FaTrash
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={() => handleDeleteRow(item.id)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {isFormModalOpen && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{ color: "#b15cd6" }}>
                            {editId ? "Edit Coupon" : "Add Coupon"}
                        </h3>

                        {platformFormFields.map((field) => (
                            <div key={field.name} style={{ marginBottom: "10px" }}>
                                {field.type === "checkbox" ? (
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="checkbox"
                                            name={field.name}
                                            checked={formData[field.name]}
                                            onChange={handleChange}
                                        />
                                        {formData[field.name] ? "Active" : "Inactive"}
                                    </label>
                                ) : field.type === "file" ? (
                                    <>
                                        <label>{field.label}:</label>
                                        <input type="file" accept="image/*" onChange={handleImageChange} />
                                    </>
                                ) : (
                                    <>
                                        <label>{field.label}:</label>
                                        <input
                                            type={field.type}
                                            name={field.name}
                                            value={formData[field.name]}
                                            onChange={handleChange}
                                            style={inputStyle}
                                        />
                                    </>
                                )}
                            </div>
                        ))}

                        <div style={{ marginTop: "20px", textAlign: "right" }}>
                            {editId ? (
                                <button onClick={handleUpdateSubmit} style={saveButtonStyle}>Update</button>
                            ) : (
                                <button onClick={handleFormSubmit} style={saveButtonStyle}>Save</button>
                            )}
                            <button onClick={() => setIsFormModalOpen(false)} style={closeButtonStyle}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// 🎨 Styles
const addButtonStyle = { padding: "8px 16px", backgroundColor: "#b15cd6", color: "white", border: "none", cursor: "pointer", borderRadius: "5px", width: "100px", fontWeight: "bold" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const tableHeaderStyle = { border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", backgroundColor: "#b15cd6", color: "white", padding: "8px" };
const tableCellStyle = { border: "1px solid #ddd", textAlign: "center", padding: "6px" };
const modalOverlay = { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 };
const modalContent = { backgroundColor: "white", padding: "20px", borderRadius: "8px", width: "450px", maxWidth: "90%", overflowY: "auto" };
const inputStyle = { width: "100%", padding: "8px", boxSizing: "border-box", borderRadius: "4px", border: "1px solid #ccc" };
const saveButtonStyle = { backgroundColor: "#28a745", color: "white", padding: "10px 15px", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold", marginRight: "10px" };
const closeButtonStyle = { backgroundColor: "#6c757d", border: "none", color: "#fff", padding: "10px 15px", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" };

export default Cateringsaddcoups;
